<div class="interaction-dialog">
    <div class="popup-msg-content" ng-class="{alert:options.alert}">
        <h1>{{$ctrl.header|translate:language}}</h1>
        <div>
            <c-list-picker-nx config="$ctrl.listPickerConfig" selected-item-ids="$ctrl.selectedTemplateIds" static-items="$ctrl.selectedTemplates"></c-list-picker-nx>
        </div>
    </div>
    <div class="popup-button-content">
        <span><button class="popup-msg-button btn-primary" ng-click="$ctrl.ok()" ng-class="{alert:options.alert}"><span>{{$ctrl.buttonSave}}</span></button></span>
        <span><button id="cancel" class="popup-msg-button" ng-click="$ctrl.cancel()"><span>{{$ctrl.buttonCancel}}</span></button></span>
    </div>
</div>